import { DocumentsBreadcrumbActionTypes } from './action_types'
import { DocumentsBreadcrumbMutationTypes } from './mutation_types'
import { GO_TO_FOLDER } from '../documents/action_types'

export const actions: StoreActions<DocumentsBreadcrumbActionTypes, DocumentsBreadcrumbMutationTypes> = {
  [DocumentsBreadcrumbActionTypes.ADD_BREADCRUMB_ITEM]: function ({ commit }, item) {
    commit(DocumentsBreadcrumbMutationTypes.ADD_ITEM, item)
  },
  [DocumentsBreadcrumbActionTypes.SET_BREADCRUMB_ITEMS]: function ({ commit }, items) {
    commit(DocumentsBreadcrumbMutationTypes.SET_ITEMS, items)
  },
  [DocumentsBreadcrumbActionTypes.GOTO]: function ({ commit, dispatch }, item) {
    dispatch(`documents/${GO_TO_FOLDER}`, item.id, { root: true })
    commit(DocumentsBreadcrumbMutationTypes.REMOVE_ALL_AFTER, item)
  },
  [DocumentsBreadcrumbActionTypes.RESET_BREADCRUMB]: function ({ commit }) {
    commit(DocumentsBreadcrumbMutationTypes.RESET_BREADCRUMB)
  },
}
